import { render, staticRenderFns } from "./RiskSurveyInterestInsd.vue?vue&type=template&id=d28c7b6e&"
import script from "./RiskSurveyInterestInsd.vue?vue&type=script&lang=js&"
export * from "./RiskSurveyInterestInsd.vue?vue&type=script&lang=js&"
import style0 from "./RiskSurveyInterestInsd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports